import React from "react";
import "./Carriers.css";

const carriers = [
  "1.png",
  "2.png",
  "3.png",
  "4.png",
  "5.png",
  "6.png",
  "7.png",
  "8.png",
  "9.png",
  "10.png",
  "11.png",
  "12.png",
  "13.png",
  "14.png",
  "15.png",
  "16.png",
  "17.png",
  "18.png",
  "19.png",
  "20.png",
  "21.png",
  "22.png",
  "23.png",
  "24.png",
  "25.png",
  "26.png",
  "27.png",
  "28.png",
];

function Carriers() {
  return (
    <section className="carriers-page">
      <div className="carriers-container">
        <h1>Our Trusted Carrier Partners</h1>
        <p className="carriers-subtitle">
          We work with leading insurance providers nationwide to bring you the
          best options available.
        </p>
        <div className="carriers-grid">
          {carriers.map((logo, index) => (
            <div className="carrier-logo" key={index}>
              <img
                src={`/images/carriers/${logo}`}
                alt={logo.replace(".png", "")}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Carriers;
